import {
  Button,
  Modal,
  message,
  Spin,
  Empty,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
  useRef
} from "react";
import { FilePptOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import CustomUploadNewBank from "@/hocComponents/customUploadNewBank";

const PDFModal = forwardRef((props, ref) => {
  const { record } = props;

  const uploadRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);

  useImperativeHandle(ref, () => ({
    setModalOpen: (flag) => {
      setModalOpen(flag);
    },
  }));

  useEffect(() => {
    if (!modalOpen || !record?.bankId) return;
    fetchFiles(record.bankId);
  }, [modalOpen, record]);

  const fetchFiles = async (bankId) => {
    setLoading(true);
    uploadRef.current?.initIsLoading(true);

    try {
      const res = await http.get(api.getBankByFile, {
        params: { foreignId: bankId, type: "bankStatement" },
      });

      if (res?.code !== "1") {
        message.error("Failed to load files");
        return;
      }

      const files =
        (res.data || []).map((f, index) => ({
          uid: `bankStatement-${f.id}`,
          id: f.id,
          name: f.fileDateName || f.fileName,
          fileName: f.fileDateName || f.fileName,
          allPath: f.url,
        })) || [];

      setFilePaths(files);

     
      setTimeout(() => {
        uploadRef.current?.initUpdateList(files);
      }, 0);
    } catch (e) {
      console.error(e);
      message.error("Failed to load bank files");
    } finally {
      setLoading(false);
      uploadRef.current?.initIsLoading(false);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
    setFilePaths([]);
  };

  return (
    <Modal
      title={
        <div style={{ fontSize: 24, fontWeight: "bold", color: "red" }}>
          <FilePptOutlined style={{ marginRight: 8 }} />
          VIEW INVOICE
          <div style={{ borderTop: "3px solid #3c8dbc", marginTop: 8 }} />
        </div>
      }
      centered
      open={modalOpen}
      onCancel={handleClose}
      footer={null}
      maskClosable={false}
      destroyOnClose
      width="80%"
    >
      <Spin spinning={loading}>
        <div style={{ marginTop: 24 }}>
          <CustomUploadNewBank
            ref={uploadRef}
            filePaths={filePaths}
            setFilePaths={setFilePaths}
            btnDisabled={btnDisabled}
            setBtnDisabled={setBtnDisabled}
            customConfig={{
              noUploadBtn: true,  
              noDeleteBtn: true,   
              disabled: true,
              pdfHeight: "60vh",
            }}
          />
        </div>
      </Spin>

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <Button onClick={handleClose}>Cancel</Button>
      </div>
    </Modal>
  );
});

export default PDFModal;